"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientPage/InfoSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _time = require('shared/services/time');
var _phone = require('shared/services/phone');

var _Avatar = require('web/components/Avatar');
var _components = require('web/screens/Directory/components');


















const PatientInformationSection = ({
  patientKey,
  patientName,
  orgName,
  dob,
  phone,
  email,
  foreignID,
  onEdit,
  texting,
  compact,
}) => (
  _react2.default.createElement('div', { className: "directory-page--info-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
    , _react2.default.createElement('div', { className: "directory-page--info-section--metadata", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      ,  patientName && !compact && (
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Name")
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, patientName)
        )
      )
      ,  !compact && (
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Organization")
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, orgName)
        )
      )
      ,  !_time.isDateNull.call(void 0, dob) &&
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "Date of Birth"  )
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, _time.formatDisplayDate.call(void 0, dob))
        )
      
      ,  phone &&
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Phone")
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, _phone.formatPhoneNumber.call(void 0, phone))
        )
      
      ,  phone && texting 
      ,  email &&
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Email")
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, email)
        )
      
      ,  foreignID && (
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "MRN")
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}},  foreignID )
        )
      )
      ,  _optionalChain([compact, 'optionalAccess', _ => _.created]) && (
        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Created")
          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}},  compact.created )
        )
      )
      , _react2.default.createElement(_components.InfoBtn, {
        label: "Edit details" ,
        onClick: onEdit,
        iconSrc: "/assets/icons/icon-edit-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      )
    )
    ,  !compact && _react2.default.createElement(_Avatar.PatientAvatar, { size: 72, patientKey: patientKey, className: "directory-page--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}) 
  )
)

exports. default = PatientInformationSection
